export { PromotionalMenuCard } from './promotional-menu-card.component';
export type { IPromotionalMenuCardProps } from './promotional-menu-card.component';
